import React from 'react'
import '../../Stylesheets/TableLoader.css'

function TableLoader() {
    return (
        <div className="lds-ring-table">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
        </div>
    )
}

export default TableLoader